export const AboutPage = () => {

  // Timeline boxes
  const $aboutPage = $('.about')
  const $timeline = $aboutPage.find('.wp-block-uagb-content-timeline')
  const $timelineBoxes = $timeline.find('.wp-block-uagb-content-timeline-child')

  // Timeline images
  const $firstColumnImages = $('.wp-block-column:first-child .wp-block-image'); 
  const $lastColumnImages = $('.wp-block-column:last-child .wp-block-image'); 
  const $images = joinImages($firstColumnImages, $lastColumnImages);

  function joinImages($firstColumnImages, $lastColumnImages) {
    const images = [];
    $timelineBoxes.each((index) => {
      const image = index % 2 === 0 
        ? $firstColumnImages.eq(index / 2) 
        : $lastColumnImages.eq(Math.floor(index / 2));
      images.push(image);
    });
    return $(images);
  }

  if ($aboutPage.length && $timeline.length && $timelineBoxes.length) {
    if ($timelineBoxes.length !== $images.length) {
      console.error('Unable to start the initTimeline function: the number of timeline boxes does not match the number of timeline images.')
    }
    initTimeline()
  }

  function initTimeline() {
    // Duplicate images for small devices
    $timelineBoxes.each((index, box) => {
      const image = $images[index]
      const $content = $(box).find('.uagb-timeline-content');
      const clonedImage = image.clone();
      $content.append(clonedImage);
    })
  }

}